var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAlertZj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 122,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#remove-alert-zj_svg__clip0_1_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.02 48.072l9.252 70.333a4.136 4.136 0 004.1 3.595h46.51a4.13 4.13 0 004.099-3.595l7.145-54.302 2.72-20.68H25.67l-4.649 4.65z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.493 59.967v45.49a4.135 4.135 0 004.136 4.136 4.135 4.135 0 004.135-4.136v-45.49a4.134 4.134 0 00-4.136-4.136 4.134 4.134 0 00-4.135 4.136zM36.95 59.967v45.49a4.135 4.135 0 004.136 4.136 4.135 4.135 0 004.135-4.136v-45.49a4.134 4.134 0 00-4.135-4.136 4.134 4.134 0 00-4.136 4.136zM70.036 59.967v45.49a4.135 4.135 0 004.136 4.136 4.135 4.135 0 004.136-4.136v-45.49a4.134 4.134 0 00-4.136-4.136 4.134 4.134 0 00-4.136 4.136z",
    fill: "#FF662A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.493 31.016l8.271 4.136h10.338l-4.136-10.337-8.272-2.066-6.201 8.267zM90.715 16.543L80.377 18.61v4.136l2.066 8.271 16.544-2.065-6.202-8.272-2.07-4.136z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.85 3.55a4.136 4.136 0 00-5.847 0L1.212 50.337a4.136 4.136 0 000 5.848l5.848 5.848L59.699 9.398 53.85 3.55z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.348 14.416L3.396 58.37l3.664 3.664L59.699 9.398 53.85 3.55a4.136 4.136 0 00-5.848 0l-.65.65a7.217 7.217 0 01-.005 10.216z",
    fill: "#FF662A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78 20.679l-2.065-4.136-3.758.753 1.692 3.383 6.202 8.272-12.534 1.565.126.5 16.544-2.065-6.206-8.272zM63.83 26.88l3.31 8.272h4.962l-4.136-10.337-8.271-2.066-1.96 2.61 6.095 1.522z",
    fill: "#3A3B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.908 38.637l-4.384-4.383a6.207 6.207 0 010-8.772l14.62-14.624c2.415-2.42 6.352-2.42 8.771 0l4.384 4.384-2.924 2.924-4.38-4.384a2.072 2.072 0 00-2.924 0l-14.623 14.62a2.072 2.072 0 000 2.924l4.383 4.383-2.923 2.928z",
    fill: "#FFB092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.443 0h4.136v4.136h-4.136V0z",
    fill: "#AEAFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.167 16.116l-2.521-3.277a24.122 24.122 0 0119.422-4.527l-.809 4.055a19.99 19.99 0 00-16.092 3.75z",
    fill: "#8182BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.324 20.679h4.136v4.136h-4.136v-4.136z",
    fill: "#AEAFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.85 10.338h-4.135C90.715 4.64 95.35 0 101.052 0v4.136a6.208 6.208 0 00-6.201 6.202z",
    fill: "#8182BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "remove-alert-zj_svg__clip0_1_1301"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120.068v122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/remove-alert-zj.fa1ce4ba.svg";
export { SvgRemoveAlertZj as ReactComponent };